<template>
  <div>
    <h1 align="center">
      Данное приложение создано в результате изучения Vue 3
    </h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
